import React from 'react'
import MediaQueryWrapper from './MediaQueryWrapper'
import { minWidthLg } from 'shared/breakpoints'

const DesktopView = (props) => {
  const newProps = { ...props, minWidth: minWidthLg }

  return <MediaQueryWrapper {...newProps} />
}

export default DesktopView
